import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function System(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "System", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.4618 2.44582h26.8948c.2451-.00109.488.04639.7148.1397.2267.09331.4326.23061.606.40396.1733.17335.3106.37932.4039.60602.0933.22671.1408.46965.1397.7148v14.8828c.0011.2452-.0464.4881-.1397.7148s-.2306.4327-.4039.6061c-.1734.1733-.3793.3106-.606.4039-.2268.0933-.4697.1408-.7148.1397H10.4618c-.2444 0-.48648-.0483-.71223-.1421-.22574-.0938-.43074-.2312-.60322-.4045-.17247-.1732-.30903-.3788-.40183-.605-.09279-.2261-.14-.4684-.13892-.7129V4.3103c-.00108-.24446.04613-.48672.13892-.71288.0928-.22616.22936-.43177.40183-.60501.17248-.17324.37748-.31071.60322-.40451.22575-.0938.46783-.14208.71223-.14208Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.4613 3.54297c-.1003.00119-.1992.02222-.2913.06187-.092.03965-.17528.09713-.24499.16913-.14239.14215-.22251.33503-.22275.53624V19.1931c0 .2013.07997.3943.22231.5366.14233.1424.33543.2223.53673.2223H37.356c.2013 0 .3943-.0799.5367-.2223.1423-.1423.2223-.3353.2223-.5366V4.31021c-.0003-.20121-.0804-.39409-.2228-.53624-.1421-.1424-.335-.22252-.5362-.22275H10.4613v-.00825Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.02533 20.9587c-.24725 0-.48437.0982-.6592.273-.17483.1749-.27304.412-.27304.6592 0 .2473.09821.4844.27304.6592.17483.1748.41195.2731.6592.2731H38.7993c.2472 0 .4843-.0983.6592-.2731.1748-.1748.273-.4119.273-.6592 0-.2472-.0982-.4843-.273-.6592-.1749-.1748-.412-.273-.6592-.273H9.01708h.00825Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M24.8419 23.3099v11.1622h-1.8644V23.3099h1.8644Z", fill: theme.vars.palette.primary.dark }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M6.13886 32.6155v-4.6529H41.6795v4.6529h-1.8562v-2.7967H8.00334v2.7967H6.13886Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("rect", { fill: theme.vars.palette.secondary.dark, height: "9.68", rx: "1", width: "10.56", x: "35.4404", y: "33.6802" }),
    /* @__PURE__ */ jsx("rect", { fill: theme.vars.palette.primary.light, height: "9.68", rx: "1", width: "10.56", x: "2", y: "33.68" }),
    /* @__PURE__ */ jsx("rect", { fill: theme.vars.palette.secondary.main, height: "9.68", rx: "1", width: "10.56", x: "18.7197", y: "35.4399" })
  ] });
}
System.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "System"
};
validateTidalLicense();
export {
  System
};
//# sourceMappingURL=System.js.map
